import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../actions/registrationActions';
import { push } from 'connected-react-router';
import { Container, Segment, Grid, Button, Header } from 'semantic-ui-react';

class ConfirmEmailChangePage extends Component {
	constructor(props) {
		super(props);

		var query = new URLSearchParams(this.props.location.search);
		var code = query.get("code");
		var userId = query.get("userId");
		var email = query.get("email");

		this.props.actions.confirmChangeEmail({ code, userId, email });
		this.onLoginClick = this.onLoginClick.bind(this);
	}

	onLoginClick() {
		this.props.actions.push('/');
	}

	render() {
		return (
			<Segment>
				<Container>
					<Grid columns='equal'>
						<Grid.Row>
							<Grid.Column />
							<Grid.Column width={8}>
								<div className='logo-signin' />
							</Grid.Column>
							<Grid.Column />
						</Grid.Row>
						<Grid.Row>
							<Grid.Column />
							<Grid.Column width={16} className='column-center'>
								<Header as='h2' content='Thank you for confirming your email address.' />
								<div className='row-center'>
									<Button primary onClick={this.onLoginClick}>
										Login
									</Button>
								</div>
							</Grid.Column>
							<Grid.Column />
						</Grid.Row>
					</Grid>
				</Container>
			</Segment>
		);
	}
}

ConfirmEmailChangePage.propTypes = {
	actions: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators({ push }, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailChangePage);
